exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.level[data-v-84156e90] {\n    margin: 0\n}\n.modal-shade[data-v-84156e90] {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 700;\n    cursor: pointer;\n}\n.modal-window[data-v-84156e90] {\n    width: 80%;\n    max-width: 50rem;\n    height: 80%;\n    z-index: 710;\n    cursor: default;\n}\n.modal-window-wide[data-v-84156e90] {\n    max-width: 70rem;\n}\n.title-row[data-v-84156e90] {\n    display: flex;\n    justify-content: space-between;\n}\n", ""]);

// exports
